import { makeStyles } from "@fluentui/react-components";
import React, { useEffect } from "react";
import { Header } from "./components/Header";
import { Content } from "./components/Content";
import { dbWakeUp } from "./api/signApi";
const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    "& > *": {
      marginLeft: "160px",
      marginRight: "160px",
      "@media (max-width: 600px)": {
        marginLeft: "16px",
        marginRight: "16px",
      },
    },
    "*": {
      boxSizing: "border-box",
    },
  },
});

export const App = () => {
  const styles = useStyles();

  useEffect(() => {
    dbWakeUp();
  }, []);

  return (
    <div className={styles.root}>
      <Header />
      <Content />
    </div>
  );
};
